export const sortOptions = [
    {
        label: "Performance",
        values: [
            { name: "Best", value: "best" },
            { name: "Worst", value: "worst" },
        ],
    },
    {
        label: "Hook Rate",
        values: [
            { name: "High to low", value: "hook_high" },
            { name: "Low to high", value: "hook_low" },
        ],
    },
    {
        label: "CPM",
        values: [
            { name: "High to low", value: "cpm_high" },
            { name: "Low to high", value: "cpm_low" },
        ],
    },
    {
        label: "Hold Rate",
        values: [
            { name: "High to low", value: "hold_high" },
            { name: "Low to high", value: "hold_low" },
        ],
    },
    {
        label: "CPC",
        values: [
            { name: "High to low", value: "cpc_high" },
            { name: "Low to high", value: "cpc_low" },
        ],
    },
];
